!function(t){"use strict"}(jQuery);
//# sourceMappingURL=scripts.min.js.map
